import React, { forwardRef } from 'react';
import Form from 'rsuite/Form';
import Input from 'rsuite/Input';
export {projectBriefLength};

let projectBriefLength = 0;

const Textarea = forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);

export default function FieldTextarea({
  name,
  label,
  required,
  numberRows,
  ...rest
}) {

    const onChange = (event) => {
        projectBriefLength = event.length;
    };

  return (
    <Form.Group controlId={name} className="field field-textarea-wrapper">
      {label && (
        <Form.ControlLabel>
          {label}
          {required && (<sup>*</sup>)}
        </Form.ControlLabel>
      )}
      <Form.Control
        name={name}
        rows={numberRows ? numberRows : 3}
        cols={30}
        accepter={Textarea}
        onChange={onChange}
        {...rest}
      />
    </Form.Group>
  );
}
